/* Nibbo cart drawer.
 *
 * Progressive enhancement. Every form this touches already works without it:
 * add-to-cart posts to /cart, the header cart is a real link. If this file
 * fails to load, or JS is off, the store still sells.
 *
 * The drawer HTML is never built here. It is re-rendered by Shopify from
 * sections/cart-drawer.liquid via the Section Rendering API, so the free
 * shipping threshold, the multi-buy tier and the totals are computed in exactly
 * one place — Liquid. Recomputing the threshold in JS would create a second
 * copy of a number that lives in theme settings, and one of the two would go
 * stale the first time it changed.
 */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';
  var root = document.getElementById('cart-drawer');
  if (!root) return;

  var lastFocus = null;
  var busy = false;

  function panel() { return root.querySelector('.drawer__panel'); }

  /* ---- open / close ---------------------------------------------------- */

  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('data-open', 'true');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-drawer-open');
    var p = panel();
    if (p) p.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    root.setAttribute('data-open', 'false');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-drawer-open');
    document.removeEventListener('keydown', onKey);
    // Send focus back where it came from, or the cart link as a fallback —
    // never leave it stranded on a hidden element.
    var back = lastFocus && document.contains(lastFocus)
      ? lastFocus
      : document.querySelector('.header__cart');
    if (back) back.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;

    // Focus trap. A modal that lets Tab wander behind it is worse than no modal.
    var p = panel();
    if (!p) return;
    var f = p.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---- re-render from Liquid ------------------------------------------- */

  function paint(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('cart-drawer');
    if (!next) return;
    var wasOpen = root.getAttribute('data-open') === 'true';
    root.innerHTML = next.innerHTML;
    root.setAttribute('data-open', wasOpen ? 'true' : 'false');
    root.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
    syncCount(doc);
  }

  function syncCount(doc) {
    var badge = document.querySelector('.header__cart-count');
    var fresh = doc.querySelector('.drawer__count');
    if (badge && fresh) badge.textContent = fresh.textContent.trim();
  }

  function refresh() {
    return fetch(window.Shopify.routes.root + '?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j[SECTION]) paint(j[SECTION]); });
  }

  /* ---- add to cart ------------------------------------------------------ */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    if (busy) return;
    busy = true;

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var body = new FormData(form);
    body.append('sections', SECTION);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'add failed');
        if (res.j.sections && res.j.sections[SECTION]) paint(res.j.sections[SECTION]);
        else return refresh();
      })
      .then(function () { open(); })
      .catch(function () {
        // Anything unexpected — sold out, a variant that vanished, offline —
        // hand the customer back to the real cart page rather than failing
        // silently with a button that did nothing.
        form.submit();
      })
      .finally(function () {
        busy = false;
        if (btn) btn.removeAttribute('aria-busy');
      });
  });

  /* ---- quantity -------------------------------------------------------- */

  root.addEventListener('click', function (e) {
    var close_ = e.target.closest('[data-drawer-close]');
    if (close_) { close(); return; }

    var q = e.target.closest('[data-qty-change]');
    if (!q || busy) return;
    busy = true;
    q.setAttribute('aria-busy', 'true');

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: Number(q.getAttribute('data-line')),
        quantity: Number(q.getAttribute('data-to')),
        sections: SECTION
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.sections && j.sections[SECTION]) paint(j.sections[SECTION]);
        else return refresh();
      })
      .catch(function () { window.location.href = window.Shopify.routes.root + 'cart'; })
      .finally(function () { busy = false; });
  });

  /* ---- header cart opens the drawer instead of navigating -------------- */

  var link = document.querySelector('.header__cart');
  if (link) {
    link.addEventListener('click', function (e) {
      // Let modified clicks through — someone cmd-clicking wants a new tab,
      // and hijacking that is the kind of thing that makes people distrust a site.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      refresh().then(open).catch(function () { window.location.href = link.href; });
    });
  }
})();
